// Tijden van de aanloop ("Opladen"). Die staan hier en niet in de CSS, want
// het beeld en het geluid moeten op dezelfde tel lopen: elk blokje dat
// aanspringt is een tik die je hoort. De blokjes krijgen hun vertraging als
// inline stijl mee (animations/AnimationLayer.js) en het geluid rekent met
// precies dezelfde getallen (audio/cues.js).
//
// Het idee: de blokjes komen eerst traag en daarna steeds sneller, tot de rij
// vol is. Dat is wat een aanloop doet - je weet dat er iets komt voor je weet
// wat het is.

export const chargeCells = 16;

// Zo lang duurt het voor het eerste blokje komt: het beeld moet eerst donker
// zijn en de kop moet staan.
export const chargeStartMs = 300;

// De tijd tussen twee blokjes, van het eerste gat naar het laatste.
export const chargeFirstGapMs = 170;
export const chargeLastGapMs = 55;

// Wanneer blokje `index` aanspringt, vanaf het begin van de animatie.
export function chargeCellMs(index) {
  const gaps = chargeCells - 1;
  let at = chargeStartMs;
  for (let i = 0; i < index; i += 1) {
    at += chargeFirstGapMs - (chargeFirstGapMs - chargeLastGapMs) * (i / gaps);
  }
  return Math.round(at);
}

// De rij is dan vol. Daar hangt de flits aan vast, en daarna valt de
// aankondiging (chargeHandoff in hooks/useSaleEvents.js).
export const chargeFullMs = chargeCellMs(chargeCells - 1);

// Hoe lang de hele animatie staat. Langer dan de flits, want het donker moet
// blijven staan tot het donker van de aankondiging het overneemt; zou dit
// eerder weggaan, dan licht het scherm daartussen even op.
export const chargeMs = 2600;
